'use client'

import SiteOnLoading from "@/components/common/siteOnLoading";
import { createContext, ReactNode, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import useTheme, { Theme } from "@/hooks/useTheme";
import customAlert from "@/util/customAlert";
import redirectInappToChrome from "@/util/redirectInappToChrome";
import { useLocale, useTranslations } from "next-intl";

export type deviceSizeType = "xl" | "lg" | "md" | "sm"
export const DeviceContext = createContext<{
    deviceWidth: number
    mobileMode: boolean
    theme: "dark" | 'light'
    HandleSelectTheme: Function
}>({
    deviceWidth: 0,
    mobileMode: isMobile ? true : false,
    theme: 'dark',
    HandleSelectTheme: () => { }
})

export default function DeviceProvider({ children }: { children: ReactNode }) {
    const [mobileMode, setMobileMode] = useState<boolean>(isMobile ? true : false)
    const [deviceWidth, setDeviceWidth] = useState<number>(0)

    const [loading, setLoading] = useState<boolean>(true)
    const [theme, setTheme] = useTheme();

    const locale = useLocale();
    const a = useTranslations("Sentence")

    function HandleSelectTheme(theme: Theme) {
        setTheme(theme)
    }
    // 리사이즈 시 너비 ,높이 세팅
    function handleResize() {
        setDeviceWidth(window.innerWidth)
    };
    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [])

    useEffect(() => {
        const { isSamsung, version } = isSamsungInternet();
        if (isSamsung) {
            // 삼성 브라우저 감지
            customAlert(a("browserRecommendation"), 'warning')
        }
        redirectInappToChrome(true, locale);

    }, [])
    useEffect(() => {
        setMobileMode(isMobile)
    }, [isMobile])
    useEffect(() => {
        let mode: string;
        if (mobileMode)
            mode = 'mobile'
        else
            mode = 'PC'

        document.documentElement.setAttribute('media-device', mode)

        setLoading(false)
    }, [mobileMode])
    useEffect(() => {
        document.documentElement.setAttribute('class', theme)
    }, [theme])

    const returnValue = {
        deviceWidth,
        mobileMode,
        theme,
        HandleSelectTheme
    }
    return (
        <DeviceContext.Provider value={returnValue}>
            {
                loading
                    ? <SiteOnLoading />
                    : children
            }
        </DeviceContext.Provider>
    )
}

function isSamsungInternet(): { isSamsung: boolean; version?: string } {
    if (typeof navigator === "undefined") return { isSamsung: false };

    const ua = navigator.userAgent || "";

    // Samsung Internet typical token: "SamsungBrowser/17.0" 등
    const m = ua.match(/SamsungBrowser\/([0-9.]+)/i);
    if (m) {
        return { isSamsung: true, version: m[1] };
    }

    // 보수적 페일백: 기기 모델에 "SAMSUNG" 또는 "Samsung" 표기가 있는 경우
    // (단, 동일 기기에서 Chrome 등 다른 브라우저가 사용될 수 있으므로 완전 보장 아님)
    if (/SAMSUNG|Samsung/i.test(ua) && /Android/i.test(ua)) {
        return { isSamsung: true };
    }

    return { isSamsung: false };
}